module.exports = __webpack_public_path__ + "img/content1-2.33dd9f6a.webp";